import WaitingModal from './WaitingModal';

export default WaitingModal;
